import React from 'react';
import { Timeline, Icon } from 'rsuite';
import 'rsuite/lib/styles/index.less';
import 'rsuite/dist/styles/rsuite-default.css';
import './timeline.css';
import './tooltip.css';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { EXAMS_STATUS_ID, GENERAL_STATUS_COSTANTS } from '../utils/jsCostants';

export const TimelineServiceItemMobile = ({
  period,
  status,
  type,
  generalStatus,
  descriptionDischargeDisplay,
  index,
  show,
  handleClick,
  lengthServicesArray,
  descriptionUrgency,
  dischargeDisplayContainerClass
}) => {

  const tooltipTypes = {
    accettazione: {
      descr: "accettazione",
      positionNumbers: {
        top: -3.9,
        left: 2.7
      }
    },
    incorso: {
      descr: "incorso",
      positionNumbers: {
        top: -.6 + (index - 1) * 3.33,
        left: 2.7
      }
    },
    eseguito: {
      descr: "eseguito",
      positionNumbers: {
        top: -.6 + (index - 1) * 3.33,
        left: 2.7
      }
    }
  };

  const renderTooltip = (serviceType) => {
    return (
      <div className="tooltip-container show"
        style={{
          fontSize: "67.5%",
          top: `${serviceType.positionNumbers.top}rem`,
          left: `${serviceType.positionNumbers.left}rem`
        }}>
        {intl.formatMessage({ id: `monitoraggioPazientePage.infoStatus.${serviceType.descr}` })}
        <div className="tooltip-arrow" style={{ top: "3rem", left: "-9.1rem" }} />
      </div>
    );
  }

  const intl = useIntl();

  let timelineCmp = null;
  if (index === 0) {

    const { start } = period;
    const labelData = moment(start).format('ddd, D MMMM YYYY');
    const labelOrario = moment(start).format('HH:mm');

    timelineCmp = (
      <>
        <b className="time" style={{ fontSize: "11px", left: '1em', top: '-2em', position: 'absolute', color: 'rgb(161,161,161)', marginTop: '0.5em' }}>{labelData}</b>
        <div style={{ marginBottom: "0" }} onClick={() => handleClick(index)}>
          {show ? renderTooltip(tooltipTypes.accettazione) : null}
          <Timeline className="custom-timeline" style={{ marginTop: '0.5em' }}>
            <Timeline.Item dot={
              <>
                <Icon size="2x" style={{ background: '#fff' }} />
                <p className="time" style={{ fontSize: "16px", left: '-3.5em', top: '-0.75em', position: 'absolute', color: 'rgb(161,161,161)' }}>{labelOrario}</p>
              </>
            }
            >
              <p style={{ fontSize: "70%", textTransform: 'capitalize', position: 'relative', top: '-.4rem' }}><b>{intl.formatMessage({ id: 'monitoraggioPazientePage.statiTrattamento.accettazione' })}</b></p>
              {descriptionUrgency &&
                <>
                  <p style={{ fontSize: "55%", display: 'inline', position: 'relative', top: '-1rem' }}>
                    {descriptionUrgency}
                  </p>
                </>}
            </Timeline.Item>
          </Timeline>
        </div>
      </>
    );
  } else if (status === EXAMS_STATUS_ID.RICHIESTO) {
    timelineCmp = (
      <div>
        <Timeline className="custom-timeline" id={lengthServicesArray === index + 1 && generalStatus === GENERAL_STATUS_COSTANTS.DIMESSO ? "last-item" : "dashed-item"} >
          <Timeline.Item id="dashed-dot">
            <>
              <p style={{
                color: "gray",
                fontSize: "70%",
                textTransform: 'capitalize',
                position: 'relative',
                top: '-.4rem'
              }}><b>{type}</b></p>
              <br />
            </>
          </Timeline.Item>
        </Timeline>
      </div>
    );
  } else if (status === EXAMS_STATUS_ID.IN_CORSO) { // TODO: label position
    timelineCmp = (
      <>
        <div onClick={() => handleClick(index)}>
          {show ? renderTooltip(tooltipTypes.incorso) : null}
          <Timeline className="custom-timeline" id={lengthServicesArray === index + 1 && generalStatus === GENERAL_STATUS_COSTANTS.DIMESSO ? "last-item" : null}>
            <Timeline.Item
              dot={
                <Icon
                  icon="circle-o"
                  size="2x"
                  style={{ background: '#092451', color: '#fff', marginLeft: "2.5px" }}
                />
              }
            >
              <>
                <p style={{
                  color: "gray",
                  fontSize: "70%",
                  textTransform: 'capitalize',
                  position: 'relative',
                  top: '-.4rem'
                }}><b>{type}</b></p>
                <br />
              </>
            </Timeline.Item>
          </Timeline>
        </div>
      </>
    );
  } else if (status === EXAMS_STATUS_ID.COMPLETATO) {
    timelineCmp = (
      <>
        <div onClick={() => handleClick(index)}>
          {show ? renderTooltip(tooltipTypes.eseguito) : null}
          <Timeline className="custom-timeline" id={lengthServicesArray === index + 1 && generalStatus === GENERAL_STATUS_COSTANTS.DIMESSO ? "last-item" : null}>
            <Timeline.Item>
              <>
                <p style={{ color: "gray", fontSize: "70%", textTransform: 'capitalize', position: 'relative', top: '-.4rem' }}><b>{type}</b></p>
                <br />
              </>
            </Timeline.Item>
          </Timeline>
        </div>
      </>
    );
  } else if (status === EXAMS_STATUS_ID.ELABORAZIONE) {
    timelineCmp = (
      <div>
        <Timeline className="custom-timeline" id={lengthServicesArray === index + 1 && generalStatus === GENERAL_STATUS_COSTANTS.DIMESSO ? "last-item" : "dashed-item"}>
          <Timeline.Item id="dashed-dot">
            <>
              <p style={{
                color: "gray",
                fontSize: "70%",
                textTransform: 'capitalize',
                position: 'relative',
                top: '-.4rem'
              }}><b>{type}</b></p>
              <br />
            </>
          </Timeline.Item>
        </Timeline>
      </div>
    );
  }

  return (
    <>
      {timelineCmp}
      {
        lengthServicesArray === index + 1 && generalStatus === GENERAL_STATUS_COSTANTS.DIMESSO ? (
          <div className={dischargeDisplayContainerClass === "container-discharge-display-totem" ? `container-fluid ${dischargeDisplayContainerClass}` : dischargeDisplayContainerClass}>
            <b style={{ fontSize: '55%' }}>{'Esito della dimissione:'}</b>
            <div style={{ fontSize: '55%' }}>{descriptionDischargeDisplay}</div>
          </div>
        ) : null
      }
    </>
  );
}